import {useState} from "react";
import {Button, Image, Input, Radio, Space, Toast} from "antd-mobile";
import {useLocation, useNavigate} from "react-router-dom";
import {azampayMnoCheckout} from "../../common/ApiAction";
import {TOASTDURATION} from "../../common/Utils";

const PROVIDERS = [
    {label: 'Airtel', value: 'Airtel'},
    {label: 'Tigo', value: 'Tigo'},
    {label: 'Halopesa', value: 'Halopesa'},
    {label: 'Azampesa', value: 'Azampesa'},
    {label: 'Mpesa', value: 'Mpesa'},
];

const AzamPayPay = () => {
    const navigate = useNavigate()
    const {state} = useLocation();
    const orderNo = state?.orderNo || '';

    const [provider, setProvider] = useState<string>('')
    const [accountNumber, setAccountNumber] = useState<string>(state?.mobile || '')
    const [amount, setAmount] = useState<string>('')

    const submitAction = () => {
        if (!provider) {
            Toast.show({content: "Please select a provider", duration: TOASTDURATION})
            return
        }
        if (!accountNumber) {
            Toast.show({content: "Please enter your phone number", duration: TOASTDURATION})
            return
        }
        if (!amount) {
            Toast.show({content: "Please enter the amount", duration: TOASTDURATION})
            return
        }
        Toast.show({icon: 'loading', content: 'Processing...', duration: 0})
        const data = {
            accountNumber,
            amount,
            provider,
            orderNo
        }
        azampayMnoCheckout(data).then((res: any) => {
            Toast.clear();
            if (!res.executed) {
                Toast.show({icon: 'fail', content: res.message || 'Payment failed', duration: TOASTDURATION})
            } else {
                Toast.show({icon: 'success', content: "Payment initiated successfully!", duration: TOASTDURATION, afterClose: () => navigate('/azampay/orders', {state: {mobile: state?.mobile}})})
            }
        }).catch(err => {
            Toast.clear();
            Toast.show({icon: 'fail', content: err.message || 'Payment failed', duration: TOASTDURATION})
        })
    }

    const back = () => {
        navigate(-1)
    }

    return <div style={{width: '100%', minHeight: '100vh', backgroundColor: '#F5F6FA', display: "flex", flexDirection: "column", alignItems: "center"}}>
        <div style={{width: '100%', display: 'flex', justifyContent: 'flex-start', padding: '10px 15px', backgroundColor: '#FFF'}}>
            <span style={{fontSize: 16, fontWeight: 'bold', cursor: 'pointer'}} onClick={back}>← Back</span>
        </div>
        <div style={{display: "flex", flexDirection: "column", alignItems: "center", marginTop: 20}}>
            <Image src={require('../../assets/icon_ego_logo.jpg')} style={{width: 100}}/>
        </div>
        <div style={{borderRadius: 8, padding: '30px 0 20px 0', border: "solid #1677ff 1px", width: '90%', marginTop: 15, display: "flex", flexDirection: "column", alignItems: "center"}}>
            <span style={{fontSize: 20, fontWeight: "bold", marginBottom: 20}}>AzamPay Payment</span>
            <div style={{display: "flex", flexDirection: "row", alignItems: "center", width: '90%', marginBottom: 5}}>
                <span style={{fontSize: 14, width: 90}}>Order No:</span>
                <span style={{fontSize: 14, color: '#333', fontWeight: 500}}>{orderNo}</span>
            </div>
            <div style={{width: '90%', marginTop: 15}}>
                <span style={{fontSize: 14, fontWeight: 500, marginBottom: 8, display: 'block'}}>Provider:</span>
                <Radio.Group onChange={val => setProvider(val as string)}>
                    <Space direction='horizontal' wrap>
                        {PROVIDERS.map(p => (
                            <Radio key={p.value} style={{'--font-size': '14px', '--gap': '6px', '--icon-size': '15px'}} value={p.value}>{p.label}</Radio>
                        ))}
                    </Space>
                </Radio.Group>
            </div>
            <div style={{display: "flex", flexDirection: "row", alignItems: "center", marginTop: 20, width: '90%'}}>
                <span style={{fontSize: 14, width: 90}}>Phone Number:</span>
                <Input value={accountNumber} onChange={val => setAccountNumber(val)} type={'number'} style={{"--font-size": '14px', flex: 1, border: "solid #cccccc 1px", borderRadius: 4}} placeholder={"e.g. 255xxxxxxxxx"}/>
            </div>
            <div style={{display: "flex", flexDirection: "row", alignItems: "center", marginTop: 20, width: '90%'}}>
                <span style={{fontSize: 14, width: 90}}>Amount (TZS):</span>
                <Input onChange={val => setAmount(val)} type={'number'} style={{"--font-size": '14px', flex: 1, border: "solid #cccccc 1px", borderRadius: 4}} placeholder={"Enter amount"}/>
            </div>
        </div>
        <div style={{marginTop: 30}}>
            <Button shape='rounded' style={{backgroundColor: '#1677ff', color: '#FFF', paddingLeft: 40, paddingRight: 40}} onClick={submitAction}>Confirm Payment</Button>
        </div>
    </div>
}
export default AzamPayPay